export default __webpack_public_path__ + "static/media/cat.0c23d8e8.png";